import React from 'react';
import {Button} from 'reactstrap';

export default class MyErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    let lastReload = localStorage.getItem("lastReload", 0);
    let lastReloadTime = Date.now() - lastReload;

    if(lastReloadTime > 500000){
      localStorage.setItem("lastReload", Date.now());
      window.location.reload(true);
    }

    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
  }

  onClick(){
    window.location.reload(true);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <><h1>Jotain meni pieleen.</h1><Button className="mt-3" color="primary" onClick={this.onClick}>Yritä uudelleen</Button></>;
    }

    return this.props.children;
  }
}
